var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalClicks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.07495L9 4.49995",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82344 6.00002L1.64844 5.40002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50313 9L3.07812 10.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 1.65002L5.99844 3.82502",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77579 7.26749C6.74671 7.19898 6.73875 7.12334 6.75296 7.05028C6.76716 6.97722 6.80286 6.91007 6.85549 6.85744C6.90812 6.80481 6.97527 6.76911 7.04833 6.75491C7.12139 6.74071 7.19703 6.74866 7.26554 6.77774L15.5155 10.1527C15.589 10.1829 15.6509 10.2355 15.6925 10.3031C15.7342 10.3707 15.7532 10.4497 15.7471 10.5288C15.7409 10.608 15.7098 10.6831 15.6582 10.7434C15.6066 10.8037 15.5372 10.8461 15.46 10.8645L12.1983 11.6452C12.0636 11.6774 11.9405 11.7462 11.8426 11.844C11.7446 11.9419 11.6756 12.0649 11.6433 12.1995L10.8633 15.462C10.8451 15.5395 10.8028 15.6091 10.7424 15.6609C10.682 15.7128 10.6067 15.744 10.5273 15.7502C10.448 15.7564 10.3688 15.7372 10.3011 15.6953C10.2334 15.6535 10.1807 15.5912 10.1508 15.5175L6.77579 7.26749Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClicks);
export default __webpack_public_path__ + "static/media/total-clicks.897ccf443ec00c68dc8a93212e3ca469.svg";
export { ForwardRef as ReactComponent };